export const loadScript = (doc: Document, src: string, type = 'text/javascript') => {
  return new Promise((resolve, reject) => {
    // Check if script already exists
    if (doc.querySelector(`script[src="${src}"]`)) {
      return resolve(`Script ${src} is already loaded.`);
    }

    const script = doc.createElement('script');

    script.src = src;
    script.async = true;
    script.type = type;

    script.onload = () => resolve(`Script ${src} loaded successfully.`);
    script.onerror = () => reject(`Failed to load script: ${src}`);

    doc.head.appendChild(script);
  });
}

export const loadCSS = (doc: Document, href: string) => {
  return new Promise((resolve, reject) => {
    // Check if the CSS file is already loaded
    if (doc.querySelector(`link[href="${href}"]`)) {
      return resolve(`CSS file ${href} is already loaded.`);
    }

    const link = doc.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = () => resolve(`CSS file ${href} loaded successfully.`);
    link.onerror = () => reject(`Failed to load CSS file: ${href}`);

    doc.head.appendChild(link);
  });
}

